var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-top-info" }, [
      _c("ul", [
        _c("li", [_c("h5", [_vm._v("Musei & gallerie")])]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "before-icon-market" }, [
            _c("p", [
              _c("b", [_vm._v("100 5th ave")]),
              _vm._v(", new york city, NY")
            ]),
            _vm._v(" "),
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _vm._v("trova sulla mappa")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "before-icon-clock" }, [
            _c("p", [
              _vm._v("Orario di oggi "),
              _c("b", [_vm._v("10:00 - 17:30")])
            ]),
            _vm._v(" "),
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _vm._v("vedi tutti gli orari")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "before-icon-timer" }, [
            _c("p", [
              _c("b", { staticClass: "text-uppercase font-weight-bold" }, [
                _vm._v("Durata consigliata 2-3 ore")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96aa428c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96aa428c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/detail/TopInfo.vue
// module id = null
// module chunks = 